import * as React from "react"
import { FunctionComponent } from "react"
import {
  Wrap,
  Image,
  Placeholder,
  Table,
  ExtraWrap,
  Price,
  Td,
  SizeWrap,
  Title,
  ExtraTitle,
  SizeTitle,
  Subtitle,
  Allergies,
  TableWrap,
} from "./MenuItem.css"

export enum BadgeType {
  hot = "hot",
  new = "new",
  vegetarian = "vegetarian",
  vegan = "vegan",
}
export type Props = {
  lang: Lang
  colspan: boolean
  images: boolean
  item: {
    alergies: string
    badge: { type: BadgeType }[]
    extras: { price: string; title: string }[]
    sizes: { price: string; title: string }[]
    image: string
    price: string
    subtitle: string
    title: string
  }
}
export type Functions = {}

export type AllProps = Props & Functions
import iconHot from "../../assets/images/Hot.png"
import iconVegan from "../../assets/images/Vegan.png"
import iconNew from "../../assets/images/New.png"
import iconVegatarion from "../../assets/images/Lapas.png"
import { Lang } from "../../constants"
export const MenuItem: FunctionComponent<AllProps> = ({
  colspan,
  images,
  lang,
  item,
}) => {
  const getValue = (param, object = null) => {
    const query = object
    try {
      return lang === Lang.LV ? query[param] : query[`${param}_en`]
    } catch (e) {
      console.warn(e)
      return ""
    }
  }

  const getBadges = () => {
    return (
      item.badge && (
        <ul>
          {item.badge.map(b => {
            let icon = null
            switch (b.type) {
              case BadgeType.hot:
                icon = iconHot
                break

              case BadgeType.new:
                icon = iconNew
                break

              case BadgeType.vegan:
                icon = iconVegan
                break

              case BadgeType.vegetarian:
                icon = iconVegatarion
                break
            }
            return (
              <li key={b.type}>
                <img src={icon} height={15} />
              </li>
            )
          })}
        </ul>
      )
    )
  }
  return (
    <Wrap>
      {images && item.image && <Image src={item.image} />}
      {images && !item.image && <Placeholder />}

      <TableWrap>
        <Table>
          <tbody>
            <tr>
              <Td align="left">
                <Title>
                  {getValue("title", item)}
                  {getBadges()}
                </Title>
              </Td>
              <Td align="right">
                {Boolean(item.sizes && item.sizes.length) ? (
                  <SizeWrap>
                    {item.sizes.map(size => {
                      return (
                        <li key={getValue("title", size)}>
                          <SizeTitle>{getValue("title", size)}</SizeTitle>
                          <Price>{size.price}</Price>
                        </li>
                      )
                    })}
                  </SizeWrap>
                ) : (
                  <Price>
                    {item.price && item.price !== "0" && item.price}
                  </Price>
                )}
              </Td>
            </tr>
            <tr>
              <Td align="left" colSpan={colspan ? 2 : 1}>
                <Subtitle>{getValue("subtitle", item)}</Subtitle>
              </Td>
              {!colspan && <td></td>}
            </tr>
            <tr>
              <Td align="left">
                <Allergies>{getValue("alergies", item)}</Allergies>
              </Td>
              <>
                {item.extras && (
                  <Td align="right">
                    {item.extras.map(extra => (
                      <ExtraWrap key={getValue("title", extra)}>
                        <li>
                          <ExtraTitle>+{getValue("title", extra)}</ExtraTitle>
                          <Price>{extra.price}</Price>
                        </li>
                      </ExtraWrap>
                    ))}
                  </Td>
                )}
              </>
            </tr>
          </tbody>
        </Table>
      </TableWrap>
    </Wrap>
  )
}

export default MenuItem
